// Gift Card Settings Constants

// Default gift card settings
export const DEFAULT_GIFT_CARD_SETTINGS = {
  giftCardOptions: {
    isPurchaseEnabled: false,
    isRedemptionEnabled: false,
  },
};